module.exports = __webpack_public_path__ + "static/media/studio_back.fc58292c.png";